import { ValueOf } from '../utilities/types';

const slaUnitsOfTime = {
  MINUTE: 'minute',
  HOUR: 'hour',
  DAY: 'day',
  MONTH: 'month',
} as const;

export const slaUnitsOfTimeChoices = [
  { id: slaUnitsOfTime.MINUTE, name: 'minutes' },
  { id: slaUnitsOfTime.HOUR, name: 'hours' },
  { id: slaUnitsOfTime.DAY, name: 'days' },
  { id: slaUnitsOfTime.MONTH, name: 'months' },
];

export type SlaUnitOfTime = ValueOf<typeof slaUnitsOfTime>;

export default slaUnitsOfTime;
